if (!customElements.get('variant-option-slider')) {
  customElements.define(
    'variant-option-slider',
    class VariantOptionSlider extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-variant-option-scroll]');
        this.track = this.querySelector('[data-variant-option-progress]');
        this.indicator = this.track?.querySelector('span');
        if (!this.scroller || !this.track || !this.indicator) return;

        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.scroller);
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      update() {
        const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const hasOverflow = maxScroll > 2;
        this.track.classList.toggle('is-active', hasOverflow);
        if (!hasOverflow) return;

        const visibleRatio = Math.min(1, this.scroller.clientWidth / this.scroller.scrollWidth);
        const travelRatio = this.scroller.scrollLeft / maxScroll;
        this.indicator.style.width = `${visibleRatio * 100}%`;
        this.indicator.style.transform = `translateX(${travelRatio * ((1 - visibleRatio) / visibleRatio) * 100}%)`;
      }
    }
  );
}
